import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Card, CardAction, CardActions, CardActionButtons, CardPrimaryAction } from 'rmwc/Card';
import { Checkbox } from 'rmwc/Checkbox';
import { TextField } from 'rmwc/TextField';
import { Typography } from 'rmwc/Typography';

import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';

import { unsubscribeUser } from '../../actions/userActions';

import { wlPath } from '../../helpers/whitelabel';

const reasonsData = [
  {
    type: 'emails_too_frequent',
    text: "I'm receiving too many emails from you.",
  },
  {
    type: 'did_not_sign_up',
    text: 'I did not sign up to receive emails from you.',
  },
  {
    type: 'already_have_advisor',
    text: 'I already have an advisor.',
  },
  {
    type: 'other',
    text: 'Other',
  },
];

export class Unsubscribe extends Component {
  constructor(props) {
    super(props);
    this.state = { reasons: [], otherText: '', submitted: false };
  }

  toggleReason = (evt, type) => {
    const { reasons } = this.state;

    if (reasons.includes(type)) {
      this.setState({ reasons: reasons.filter(item => item !== type) });
    } else {
      reasons.push(type);
      this.setState({ reasons });
    }
  };

  otherTextEdit = event => {
    this.setState({ otherText: event.target.value });
  };

  submit = () => {
    const { reasons, otherText } = this.state;
    this.props.unsubscribeUser(reasons, otherText).then(() => this.setState({ submitted: true }));
  };

  reasonCheckbox = option => (
    <Checkbox id={option.type} key={option.field} onChange={e => this.toggleReason(e, option.type)}>
      {option.text}
    </Checkbox>
  );

  render() {
    return (
      <div>
        <Header fixed />
        <Card style={{ maxWidth: '600px', margin: 'auto', marginTop: '80px' }}>
          <CardPrimaryAction>
            <div style={{ padding: '0 1rem 1rem 1rem' }}>
              <Typography use="headline4" tag="h2">
                We're sad to see you leave
              </Typography>
              {this.state.submitted ? (
                <Fragment>
                  <Typography use="headline6" tag="p">
                    You have been successfully unsubscribed
                  </Typography>
                  {!!this.state.reasons.length && (
                    <Typography use="body" tag="p">
                      Thank you for your feedback
                    </Typography>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <Typography use="headline6" tag="p">
                    Let us know how we can improve:
                  </Typography>
                  {/* checkboxes / other stuff here */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>{reasonsData.map(this.reasonCheckbox)}</div>
                  {this.state.reasons.includes('other') && (
                    <TextField
                      onChange={this.otherTextEdit}
                      textarea
                      fullwidth
                      label="Please tell us your other reasons..."
                      rows="3"
                    />
                  )}
                </Fragment>
              )}
            </div>
          </CardPrimaryAction>
          {this.state.submitted || (
            <CardActions>
              <CardActionButtons>
                <CardAction onClick={this.submit}>Unsubscribe</CardAction>
              </CardActionButtons>
            </CardActions>
          )}
        </Card>
      </div>
    );
  }
}

export default connect(null, { unsubscribeUser })(Unsubscribe);
